<!-- Vue component -->
<template>
    <div>
        <multiselect
            aria-required="true"
            v-model="value"
            :options="options"
            :placeholder="placeholder"
            :multiple="multiple"
            track-by="name"
            :max="max ? max : false"
            :max-reached-label="maxLabel"
            label="name">
            <template v-slot:option="option">
                <div class="d-inline-flex">
                    {{ option.option.name }}&nbsp;
                    <tippy
                        v-if="option.option.description"
                        :content="option.option.description">
                        <template v-slot:trigger>
                        <span class="info-tooltip section__infos">
                            <svg viewBox="0 0 24 24">
                                <use xlink:href="#information"></use>
                            </svg>
                        </span>
                        </template>
                    </tippy>
                </div>
            </template>
        </multiselect>
        <select multiple :id="id" :name="inputname" style="display: none">
            <option v-for="option in getValue" :value="option.value" selected>{{ option.name }}</option>
        </select>
    </div>
</template>

<script>
import Multiselect from '../../lib/vue-multiselect/';


export default {
    components: {Multiselect},
    props: {
        options: Array,
        placeholder: String,
        selecteddata: Array,
        multiple: {
            type: Boolean,
            default: true
        },
        inputname: String,
        id: String,
        callback: Function,
        max: null,
        maxLabel: ""
    },
    data() {
        return {
            value: this.selecteddata,
        }
    },
    computed: {
        getValue() {
            return this.value;
        },
        getValuesArray() {
            return this.value.flatMap(function (item) {
                return item.value
            });
        }
    },
    watch: {
        value: {
            immediate: false,
            handler(val, oldVal) {
                this.callback ? this.callback(this.$el) : '';
            }
        },
        /*selecteddata: {
            immediate: true,
            handler (val, oldVal) {
                if (val !== undefined) {
                    this.value = val;
                }
            }
        }*/
    }
}
</script>

<style>
</style>
